var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import LoginTemplate from './html/login-template.html';
import LoginCss from './html/css/login-template.css';
import { displayText, fireEvent, hideElement, isEmpty, isFunction, isString, isWhitespace, showElement, stopEvent } from '../modules/utils';
import { HttpRequest } from './ajaxrequest';
import { PromiseDialog } from './promiseDialog';
import { EventBus } from './eventBus';
import { getMonitoringInstance } from '../interfaces/IMonitoring';
import { CobrowseAuthEndPoint } from '../modules/endPoints';
const emailValidationRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class LoginControlClass extends PromiseDialog {
    constructor() {
        var _a;
        super({ htmlContent: LoginTemplate, css: [{
                    id: 'loginTemplateCss',
                    cssContent: LoginCss
                }] }, {
            dismissOnEscape: false,
            enableOverlay: false,
            rejectOnEscape: false
        });
        this.eventBus = new EventBus();
        this.successCallback = null;
        this.rejectCallback = null;
        this.enableForgotPassword = false;
        this.enableChangePassword = false;
        this.mainServer = null;
        this.userRole = null;
        this.sessionID = null;
        this.lastErrorStatus = null;
        this.isEmail = (email) => emailValidationRegEx.test(email);
        this.onContinue = this.onContinue.bind(this);
        const loginButton = (_a = this.getContent()) === null || _a === void 0 ? void 0 : _a.querySelector('#btnContinue');
        if (loginButton !== null) {
            loginButton.onclick = this.onContinue;
        }
    }
    configure(options) {
        var _a;
        if (this.isVisible()) {
            this.reportRejectOrThrow(new Error('ERR_ALREADY_ACTIVE'));
            return;
        }
        this.configureUI(options.uiConfig);
        if (typeof (options === null || options === void 0 ? void 0 : options.enableChangePassword) === 'boolean') {
            this.enableChangePassword = options.enableChangePassword;
        }
        if (typeof (options === null || options === void 0 ? void 0 : options.enableForgotPassword) === 'boolean') {
            this.enableForgotPassword = options.enableForgotPassword;
        }
        if (typeof (options === null || options === void 0 ? void 0 : options.mainServer) === 'string') {
            this.mainServer = options.mainServer;
        }
        if (typeof options.cssContent === 'string') {
            const style = document.createElement('style');
            style.type = 'text/css';
            style.textContent = options.cssContent;
            (_a = this.getContent()) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML('afterbegin', style.outerHTML);
        }
    }
    authenticate(role, lsessionID) {
        this.setRole(role);
        if (isString(lsessionID)) {
            this.setSessionID(lsessionID);
        }
        return this.displayAsync();
    }
    displayAsync() {
        var _a, _b, _c;
        if (this.dialogPromise !== null) {
            return this.dialogPromise;
        }
        if (this.userRole === null) {
            return Promise.reject(new Error('ERR_NOT_CONFIGURED'));
        }
        const forgotPasswordRow = (_a = this.getContent()) === null || _a === void 0 ? void 0 : _a.querySelector('.forgotPassword');
        if (!isEmpty(forgotPasswordRow)) {
            if (this.enableForgotPassword) {
                showElement(forgotPasswordRow);
                const forgotPassword = forgotPasswordRow.querySelector('a');
                if (!isEmpty(forgotPassword)) {
                    forgotPassword.onclick = (e) => {
                        stopEvent(e);
                        this.eventBus.fireEvent(3);
                        return false;
                    };
                }
            }
            else {
                hideElement(forgotPasswordRow);
            }
        }
        const changePasswordRow = (_b = this.getContent()) === null || _b === void 0 ? void 0 : _b.querySelector('.changePassword');
        if (!isEmpty(changePasswordRow)) {
            if (this.enableChangePassword) {
                showElement(changePasswordRow);
                const changePassword = changePasswordRow.querySelector('a');
                if (!isEmpty(changePassword)) {
                    changePassword.onclick = (e) => {
                        stopEvent(e);
                        this.eventBus.fireEvent(4);
                        return false;
                    };
                }
            }
            else {
                hideElement(changePasswordRow);
            }
        }
        const promise = super.displayAsync();
        const login = (_c = this.getContent()) === null || _c === void 0 ? void 0 : _c.querySelector('#login');
        if (isEmpty(login === null || login === void 0 ? void 0 : login.value)) {
            this.doFocus(login);
        }
        return promise;
    }
    keyHandler(e) {
        if (!super.keyHandler(e)) {
            return false;
        }
        const keycode = e.which ? e.which : e.keyCode;
        if (keycode === 13) {
            const element = this.getContinueButton();
            if (isFunction(element.click)) {
                element.click();
            }
            else {
                fireEvent(element, 'click');
            }
            stopEvent(e);
            return false;
        }
        return true;
    }
    doFocus(element) {
        if (!isEmpty(element)) {
            try {
                element.focus();
            }
            catch (e) { }
        }
    }
    setRole(role) {
        this.userRole = role;
    }
    setSessionID(sessionID) {
        this.sessionID = sessionID;
    }
    getContinueButton() {
        var _a;
        const loginButton = (_a = this.getContent()) === null || _a === void 0 ? void 0 : _a.querySelector('#btnContinue');
        return loginButton;
    }
    getMessageText(messageID) {
        const message = this.uiConfig === null ? 'ERR_NOT_CONFIGURED' : this.uiConfig[messageID];
        return message;
    }
    displayError(messageID) {
        var _a;
        const message = this.getMessageText(messageID);
        const element = (_a = this.getContent()) === null || _a === void 0 ? void 0 : _a.querySelector('#ErrorCode');
        if (!isEmpty(element)) {
            displayText(element, message);
        }
    }
    onContinue(evt) {
        return __awaiter(this, void 0, void 0, function* () {
            stopEvent(evt);
            const loginForm = this.getContent();
            const login = loginForm === null || loginForm === void 0 ? void 0 : loginForm.querySelector('#login');
            const psw = loginForm === null || loginForm === void 0 ? void 0 : loginForm.querySelector('#password');
            if (isEmpty(login) || isEmpty(psw)) {
                this.reportRejectOrThrow(new Error('ERR_INVALID_CONTENT'));
                return;
            }
            const email = login.value;
            const password = psw.value;
            if (isEmpty(email)) {
                this.doFocus(login);
                this.displayError('missingEmail');
                return false;
            }
            else if (isEmpty(password)) {
                this.doFocus(psw);
                this.displayError('missingPassword');
                return false;
            }
            else if (!this.isEmail(email)) {
                this.doFocus(login);
                this.displayError('invalidEmail');
                return false;
            }
            else if (isWhitespace(password)) {
                this.doFocus(psw);
                this.displayError('emptyPassword');
                return false;
            }
            let endPoint = CobrowseAuthEndPoint;
            if (isString(this.mainServer)) {
                endPoint = `https://${this.mainServer}${endPoint}`;
            }
            let response;
            const headers = {
                'Content-type': 'application/json',
                'Role': this.userRole
            };
            if (isString(this.sessionID)) {
                headers['lsessionID'] = this.sessionID;
            }
            try {
                response = yield HttpRequest.post(endPoint, {
                    userLogin: email,
                    userPassword: password
                }, headers);
            }
            catch (err) {
                const apiError = err;
                if (!isEmpty(apiError.rawResponse)) {
                    response = apiError.rawResponse;
                }
                else {
                    this.eventBus.fireEvent(2, apiError);
                    console.error(err);
                    response = {
                        state: "FAIL_INVALID_LOGIN"
                    };
                }
            }
            const monitoringContext = getMonitoringInstance();
            const parsedResponse = isString(response) ? JSON.parse(response) : response;
            if (parsedResponse.state !== "SUCCESS" && parsedResponse.state !== "ok") {
                this.lastErrorStatus = parsedResponse.state;
                let messageID = null;
                switch (parsedResponse.state) {
                    case "FAIL_NOT_IN_SERVICE":
                    case "FAIL_TIME_EXPIRED":
                        messageID = 'trialExpired';
                        break;
                    case "FAIL_OVER_LIMIT":
                        messageID = 'maxNumberExceeded';
                        break;
                    case "FAIL_RESTRICTED_IP":
                        messageID = 'unauthorized';
                        break;
                    case "FAIL_PASSWORD_EXPIRED":
                        messageID = 'pwdExpired';
                        break;
                    case "FAIL_TMP_LOCK":
                        messageID = 'failTmpLock';
                        break;
                    case "FAIL_LOCK":
                        messageID = 'failLock';
                        break;
                    case "FAIL_NOT_AGENT":
                        messageID = 'authorizationFailed';
                        break;
                    default:
                        messageID = 'invalidEmailPassword';
                }
                if (parsedResponse.remainingAttemptCount === 1) {
                    messageID = 'aboutToBeLocked';
                }
                this.displayError(messageID);
                this.eventBus.fireEvent(1, parsedResponse.state);
                monitoringContext === null || monitoringContext === void 0 ? void 0 : monitoringContext.syncEvent("1", "AuthenticationError", {
                    UserLogin: email,
                    ErrorCode: parsedResponse.state,
                    ErrorMessage: this.getMessageText(messageID)
                });
            }
            else {
                this.eventBus.fireEvent(0, parsedResponse.authResponse);
                if (isFunction(this.successCallback)) {
                    this.successCallback(parsedResponse.authResponse);
                    this.successCallback = null;
                    this.rejectCallback = null;
                    this.dialogPromise = null;
                    this.hide();
                }
            }
        });
    }
}
const loginDialog = new LoginControlClass();
export const LoginControl = {
    eventBus: loginDialog.eventBus,
    authenticate: loginDialog.authenticate.bind(loginDialog),
    configure: loginDialog.configure.bind(loginDialog)
};
